// extracted by mini-css-extract-plugin
module.exports = {"swiperRow":"InfiniteSwipeShowcase_swiperRow__bOU1g"};